import { InAppSearchBox } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { useSearchFilters } from "../../../lib/useSearchFilters";

export default function SearchForm({
  query,
  setQuery,
  onSubmit,
  onInputFocus = () => {},
  getInputProps = () => ({}),
  spellCheck = true,
  iconRef
}: {
  query: string;
  setQuery: (query: string) => void;
  onSubmit?: (query: string) => void;
  filters: unknown;
  onDropdownOpen?: () => void;
  onInputFocus?: () => void;
  getInputProps?: () => object;
  spellCheck?: boolean;
  inputRef?: any;
  iconRef?: any;
}) {
  const { t } = useTranslation(
    "client\\components\\search\\mobile\\SearchForm"
  );
  const { clearSearchInputBoxRef, setFilters: setSearchFilters } =
    useSearchFilters();
  const inputRef = React.createRef<HTMLInputElement>();

  const handleSubmit = (e: $TSFixMe) => {
    e.preventDefault();

    if (iconRef.current) {
      iconRef.current.focus();
    }
    if (onSubmit) {
      onSubmit(query);
    } else {
      // Default behavior: redirect to listings page with query & user filters
      // @ts-ignore TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      setSearchFilters("Query", {
        q: query && query.length ? query : null
      });
    }
  };

  const handleChange = (e: $TSFixMe) => {
    setQuery(e.target.value);
  };

  const handleClear = () => {
    // @ts-ignore TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    setSearchFilters("Query", {
      q: null
    });
    setQuery("");
  };

  return (
    <InAppSearchBox
      onSubmit={handleSubmit}
      onClear={handleClear}
      inputProps={{
        ref: inputRef,
        placeholder: t("Any topic or teacher"),
        value: query || "",
        onFocus: onInputFocus,
        onChange: handleChange,
        spellCheck,
        getInputProps
      }}
      searchLabel={t("Submit search")}
      clearSearchInputBoxRef={clearSearchInputBoxRef}
      clearSearchAriaLabel={t("Clear")}
    />
  );
}
